import { render, staticRenderFns } from "./BaseProfileTable.vue?vue&type=template&id=30148aca&"
import script from "./BaseProfileTable.vue?vue&type=script&lang=js&"
export * from "./BaseProfileTable.vue?vue&type=script&lang=js&"
import style0 from "./BaseProfileTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports